import React from "react";
import { ICertificate } from "../../../types";

import CertificateContent from "./certificate-content";
import ViewCertificatePDF from "./pdf-certificate";

//@ts-ignore
import styled from "styled-components/macro";
const Logo = require("../../../assets/Logo.png");

interface IProps {
  certificate: ICertificate;
  imageUri: any;
}

const Certificate: React.FC<IProps> = ({ certificate, imageUri }) => {
  return (
    <Content>
      {certificate ? (
        <>
          <ActionButtonContainer>
            {imageUri ? (
              <ViewCertificatePDF
                certificate={certificate}
                imageUri={imageUri}
              />
            ) : (
              "loading...."
            )}
          </ActionButtonContainer>
          <ImageContainer>
            <Image src={Logo} />
            <CardWrapper>
              <CertificateContent certificate={certificate} />
            </CardWrapper>
          </ImageContainer>
        </>
      ) : null}
    </Content>
  );
};

export default Certificate;

const Image = styled.img`
  position: absolute;
  opacity: 0.06;
  top: 17em;
  left: 2em;
  width: 90%;
`;

const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
`;

const ActionButtonContainer = styled.div`
  display: flex;
  align-self: flex-start;
  align-items: flex-start;

  @media (max-width: 960px) {
    margin: 1rem;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  background-color: #fff;
  padding: 4rem;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  margin-top: 1rem;
  @media (max-width: 960px) {
    margin: 0rem 1rem 1rem;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10rem;

  @media (max-width: 960px) {
    margin-left: 10px;
    padding-left: 10rem;
    margin-top: 0;
  }
`;
